import { createApp } from 'vue'
import NewsApp from './components/news/NewsApp.vue'

const el = document.getElementById('news-app')

if (el && window.newsData) {
    createApp(NewsApp, { config: window.newsData }).mount(el)
}
